import type { CustomThemeDefinition } from '@/plugins/theme/types';
import colors from '@/styles/colors';
import palette from '@/styles/_colors.module.scss';

export const afTheme: CustomThemeDefinition = {
  dark: false,
  colors: {
    'on-background': colors('grey'),
    'on-surface': colors('grey'),
    primary: colors('pink'),
    secondary: colors('blue'),
    info: colors('blue', 'darken-1'),
    'info-background': colors('blue', 'lighten-4'),
    'font-secondary': colors('grey', 'darken-1'),
    'font-tertiary': colors('grey', 'lighten-1'),
    link: colors('blue'),
    success: colors('green'),
    'on-tertiary': colors('shades', 'white'),
    iconThin: colors('grey', 'darken-1'),
    iconSolid: colors('grey'),
    border: colors('grey', 'lighten-3'),
    empty: colors('grey', 'lighten-4'),
    contrast: colors('grey', 'base'),
    'on-contrast': colors('shades', 'white'),
    textContrast: colors('shades', 'white'),
    forms: colors('grey', 'lighten-4'),
    'on-forms': colors('grey', 'base'),
    error: colors('red'),
    'on-error': colors('red', 'base'),
    information: colors('blue', 'lighten-4'),
    'on-information': colors('blue', 'base'),
    errorBanner: colors('red', 'lighten-1'),
    'on-errorBanner': colors('red', 'base'),
    warningPrimary: colors('mustard'),
    warningSecondary: colors('mustard', 'lighten-4'),

    // Buttons
    borderSecondary: colors('grey', 'lighten-2'),

    // Emphasize
    emphasize1: colors('pink'),
    emphasize2: colors('teal'),

    // Overlay
    overlay: colors('grey', 'darken-1'),

    // Highlighted buttons
    btnHighlightedBackground: colors('blue', 'lighten-3'),
    btnHighlightedColor: colors('blue'),
    btnHighlightedBorder: colors('blue', 'lighten-2'),

    // Former colors (to be changed with design system implementation)
    tertiary: colors('green'),

    // Assessments
    assessmentEmpty: colors('grey', 'lighten-2'),
    assessmentVeryLow: colors('blue'),
    assessmentLow: colors('teal'),
    assessmentModerate: colors('mustard'),
    assessmentHigh: colors('orange'),
    assessmentVeryHigh: colors('pink'),
    'on-assessmentEmpty': colors('shades', 'white'),
    'on-assessmentVeryLow': colors('shades', 'white'),
    'on-assessmentLow': colors('shades', 'white'),
    'on-assessmentModerate': colors('shades', 'white'),
    'on-assessmentHigh': colors('shades', 'white'),
    'on-assessmentVeryHigh': colors('shades', 'white'),

    // Assessments PE
    shape: colors('blue'),
    move: colors('orange'),
    movebis: colors('green'),

    // Socials
    facebook: colors('branding', 'facebook'),
    'on-facebook': colors('shades', 'white'),
    linkedin: colors('branding', 'linkedin'),
    'on-linkedin': colors('shades', 'white'),
    twitter: colors('branding', 'twitter'),
    'on-twitter': colors('shades', 'white'),
    instagram: colors('branding', 'instagram'),
    'on-instagram': colors('shades', 'white'),
    google: colors('branding', 'google'),
    'on-google': colors('shades', 'white'),

    // color variations
    'decor-variant-1': colors('blue'),
    'decor-variant-2': colors('teal'),
    'decor-variant-3': colors('mustard'),
    'decor-variant-4': colors('orange'),
    'decor-variant-5': colors('pink'),

    // Empty state
    skeletonPrimary: colors('grey', 'lighten-4'),
    skeletonSecondary: colors('grey', 'lighten-3'),

    // Inputs
    inputActiveBorder: colors('grey', 'darken-1'),
    focusBorder: colors('grey', 'darken-1'),
  },
  variables: {
    'high-emphasis-opacity': 1,
    'medium-emphasis-opacity': 1,
  },
};

/**
 * Add all colors to afTheme
 */
const themeColors = Object.keys(palette).reduce((colors, key) => {
  const newKey = key.replace('|', '-').replace('-base', '');
  colors[newKey] = palette[key];
  return colors;
}, {});

afTheme.colors = {
  ...afTheme.colors,
  ...themeColors,
};
